import { render, staticRenderFns } from "./my-content.vue?vue&type=template&id=e8ff1e74&"
import script from "./my-content.ts?vue&type=script&lang=js&"
export * from "./my-content.ts?vue&type=script&lang=js&"
import style0 from "./my-content.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports